import { Component, OnInit } from '@angular/core';
import { ErrorPagesConfig } from '../../../config/error-pages.config';

@Component({
  selector: 'app-sp-page-not-found-redirect',
  template: ''
})
export class SpPageNotFoundRedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = ErrorPagesConfig.pageNotFound;
  }
}
